import * as yup from 'yup';
import {RequiredStringSchema} from 'yup/lib/string';

import {StrapiFieldErrorProps} from '../../api/models/strapi/strapi-field-error-props';

export class InputValidation {
    static password(errorMessages?: StrapiFieldErrorProps): RequiredStringSchema<string | undefined> {
        return yup
            .string()
            .required(errorMessages?.required)
            .min(12, errorMessages?.min)
            .matches(
                /.*[?=)(/&%$§“!_@-]+.*/, errorMessages?.valid)
            .matches(/.*\d+.*/, errorMessages?.valid)
            .matches(/.*[A-ZÄÖÜ]+.*/, errorMessages?.valid)
            .matches(
                /.*[a-zäöü]+.*/, errorMessages?.valid);
    }
}
